module.exports = __webpack_public_path__ + "img/vendor.396ab97f.svg";